<template>
  <div class="ws-experts__details">
    <h3 class="title is-size-5">{{ $t('Экзамены')}}</h3>
    <ws-list-view class="ws-experts__details-list is-table is-small"
                  :data="list"
                  :columns="columns"
                  :header="true"
                  :loading="isFindPending"
                  :detailed="false">
      <template slot-scope="props">
        <ws-list-view-item-column>
          <template v-if="props.row">
            <router-link :to="`/demo-exams/?humanreadble=${props.row.human_readable_id}`">
              <h2 class="ws-demo-exams__item-title is-size-5 has-text-primary has-text-weight-bold">
                <span>{{props.row.human_readable_id}}</span>
              </h2>
            </router-link>
          </template>
        </ws-list-view-item-column>
        <ws-list-view-item-column>
          <template v-if="props.row">
            <router-link :to="`/demo-exams/?humanreadble=${props.row.human_readable_id}`">
              <h2 class="ws-demo-exams__item-title is-size-5 has-text-primary has-text-weight-bold">
                <span>{{props.row.name.display}}</span>
              </h2>
            </router-link>
          </template>
        </ws-list-view-item-column>
        <ws-list-view-item-column>
          <template v-if="props.row">
             <ws-time-formatter data-id="day-cm1-column" class="is-size-4" :date="props.row.day_cm1" />
          </template>
        </ws-list-view-item-column>
        <ws-list-view-item-column>
          <template v-if="props.row">
            <span v-if="getRoleByExamId(props.row.guid)">
              {{ ROLES[getRoleByExamId(props.row.guid).role] }}
            </span>
          </template>
        </ws-list-view-item-column>
      </template>
    </ws-list-view>
    <b-loading :is-full-page="false" :active.sync="isFindPending" :can-cancel="true"></b-loading>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

const ROLES = {
  'lineal': 'Эксперт', // обычный эксперт (эксперт)
  'main': 'Главный',
  'technical': 'Технический'
}

export default {
  name: 'WsExpertsListDetails',
  props: {
    exams: Array
  },
  data () {
    return {
      ROLES,
      list: [],
      columns: [
        {
          label: 'Id'
        },
        {
          label: 'Наименование'
        },
        {
          label: 'Дата проведения'
        },
        {
          label: 'Роль эксперта'
        }
      ],
      isFindPending: false
    }
  },
  methods: {
    ...mapActions('exams', ['find']),
    async _fetch () {
      this.isFindPending = true
      this.list = await this.find({
        query: {
          guids: this.exams.map(exam => exam.guid)
        }
      })
      this.isFindPending = false
    },
    getRoleByExamId (id) {
      return this.exams.find(exam => exam.guid === id)
    }
  },
  mounted () {
    if (this.exams.length) {
      this._fetch()
    }
  }
}
</script>

<style lang="scss" scoped>
  .ws-experts__details {
    position: relative;
    //min-height: 200px;
    padding-top: 1rem;
    border-top: 1px solid #ccc;

    &-list {
      &.is-table {
        .ws-list-view__header,
        .ws-list-view__content {
          display: grid;
          grid-template-columns: 200px repeat(3, 1fr);
          grid-column-gap: 1px;
        }
      }
    }
  }
</style>
